import React, { useState } from 'react';
import { Gift, Coins, ArrowRight, Plus } from 'lucide-react';
import { rewardBrands } from '../mock';
import Reveal from './Reveal';

const RewardsSection = () => {
  const [points, setPoints] = useState(1240);

  return (
    <section id="rewards" className="py-24 relative overflow-hidden">
      <div className="pointer-events-none absolute top-1/2 -right-24 w-[420px] h-[420px] rounded-full bg-[var(--ydd-yellow)]/8 blur-[120px]" />
      <div className="container-ydd relative">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          {/* left: points wallet demo */}
          <Reveal>
            <div>
              <span className="text-[var(--ydd-yellow)] font-semibold text-sm uppercase tracking-widest">Read &amp; Earn</span>
              <h2 className="font-display text-white text-3xl md:text-5xl mt-4 leading-tight">Reading news<br />has never been<br />this rewarding</h2>
              <p className="text-gray-400 mt-5 text-lg max-w-md leading-relaxed">Simply read news every day to earn reward points. Redeem them for exclusive discounts from India's leading brands. The more you stay informed, the more you save.</p>

              {/* interactive wallet */}
              <div className="mt-8 card-ydd p-6 max-w-sm">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="h-11 w-11 rounded-xl bg-[var(--ydd-yellow)] flex items-center justify-center">
                      <Coins size={20} className="text-[#0E0E11]" />
                    </div>
                    <div>
                      <div className="text-xs text-gray-400">Your reward points</div>
                      <div className="font-display text-white text-2xl">{points.toLocaleString()}</div>
                    </div>
                  </div>
                  <button
                    onClick={() => setPoints((p) => p + 5)}
                    className="btn-yellow px-3.5 py-2 text-xs flex items-center gap-1"
                  >
                    <Plus size={14} /> Read (+5)
                  </button>
                </div>
                <div className="mt-4 h-2 rounded-full bg-white/10 overflow-hidden">
                  <div className="h-full bg-[var(--ydd-yellow)] transition-all duration-500" style={{ width: `${Math.min((points % 1500) / 15, 100)}%` }} />
                </div>
                <div className="mt-2 text-xs text-gray-500">{1500 - (points % 1500)} pts to your next ₹100 voucher</div>
              </div>
            </div>
          </Reveal>

          {/* right: brand grid */}
          <div className="grid sm:grid-cols-2 gap-5">
            {rewardBrands.map((b, i) => {
              const Icon = b.icon;
              return (
                <Reveal key={b.label} delay={(i % 2) * 100}>
                  <div className="card-ydd overflow-hidden group cursor-pointer h-full">
                    <div className="relative h-28 overflow-hidden">
                      <img src={b.img} alt={b.label} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                      <div className="absolute inset-0 bg-[#1B1B21]/50" />
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="h-11 w-11 rounded-full bg-[var(--ydd-yellow)] flex items-center justify-center">
                          <Icon size={20} className="text-[#0E0E11]" />
                        </div>
                      </div>
                    </div>
                    <div className="p-4">
                      <div className="text-white font-bold text-sm">{b.label}</div>
                      <div className="text-[var(--ydd-yellow)] text-xs font-semibold mt-1 flex items-center gap-1">
                        <Gift size={12} /> {b.offer}
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>

        <Reveal>
          <div className="mt-12 flex justify-center">
            <a href="#download" className="btn-outline-ydd px-7 py-3.5 text-[15px] flex items-center gap-2">
              Discover all rewards <ArrowRight size={18} />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default RewardsSection;
